import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.relatorio
        ? _c(
            VCard,
            { staticClass: "mb-4", attrs: { flat: "" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [_c("app-title", { attrs: { texto: "CADASTRO" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("app-title", {
                        attrs: {
                          texto: "CONDIÇÕES DE DEFICIÊNCIA",
                          cor: "secondary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("pie-chart", {
                        attrs: {
                          titulo: "Comparativo das Condições de Deficiência",
                          fonte: `Fonte: Sistema Desenvolva, ${_vm.ano}`,
                          dados: _vm.dadosPieChart.series,
                          "dados-complementares": _vm.dadosPieChart.subSeries,
                          "is-get-svg": _vm.isGetSvg,
                        },
                        on: { svg: (value) => (_vm.svg = value) },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("app-title", {
                        attrs: { texto: "RESULTADOS", cor: "secondary" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("tabela-resultado", {
                        attrs: { relatorio: _vm.relatorio },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-end mb-1" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { "max-width": "400", top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      attrs: { color: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getRelatorio()
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c(VIcon, [_vm._v("get_app")]),
                                    _vm._v(" BAIXAR PDF "),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3755186528
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Clique para baixar o relatório dos dados em formato PDF."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }